import { Index } from "@/routes"
import CatchAll from "../routes/catch-all"
import { Dashboard } from "../routes/dashboard"
import { Root } from "../routes/root"
import { RootRoute, Route, Router } from "@tanstack/react-router"
import { Billing } from "@/routes/billing"
import { Settings } from "@/routes/settings"
import { AmazonRedirect } from "@/routes/amazon-redirect"
import { AmazonConnect } from "@/routes/amazon-connect"
import { Integration } from "@/components/integration"
import { AlexaLink } from "@/routes/alexa-link"

export const localStorageTokenKey = "token"

const rootRoute = new RootRoute({
  component: Root,
})

const catchRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "*",
  component: CatchAll,
})

const dashboardRoute = new Route({
  getParentRoute: () => rootRoute,
  id: "dashboard",
  component: Dashboard,
})

export const indexRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/",
  component: Index,
})

// START DASHBOARD PAGES ---------------------

export const integrationRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/integrations/$integrationId",
  component: Integration,
})

const settingsRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/settings",
  component: Settings,
})
const billingRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/billing",
  component: Billing,
})

const amazonRedirectRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/amazon/authorize",
  component: AmazonRedirect,
})

const amazonConnectRoute = new Route({
  getParentRoute: () => dashboardRoute,
  path: "/amazon/connect",
  component: AmazonConnect,
})

// END DASHBOARD PAGES -----------------------

const alexaLinkRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/oauth",
  component: AlexaLink,
})

const routeTree = rootRoute.addChildren([
  dashboardRoute.addChildren([
    integrationRoute,
    settingsRoute,
    billingRoute,
    amazonRedirectRoute,
    amazonConnectRoute,
  ]),
  alexaLinkRoute,
  catchRoute,
  indexRoute,
])

export const router = new Router({ routeTree })

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
